import { Skeleton } from '@material-ui/lab'
import React, { FC, ReactElement } from 'react'

type Props = {
    tabs: number
    sections: number
}

/**
 * Add code loader
 */
export const ModalLoading: FC<Props> = ({ tabs, sections }: Props): ReactElement => (
    <div className='tabs-content-loader modal-add-loading'>
        <div className='tabs-menu-loaders'>
            {[...Array<number>(tabs)].map((item, i) => (
                <Skeleton key={`${item}-${i}`} variant='text' width='100%' height={40} />
            ))}
        </div>
        <div className='tabs-content-loaders'>
            <div className='section'>
                {[...Array<number>(sections)].map((item, i) => (
                    <Skeleton key={`${item}-${i}`} variant='text' width='100%' height={45} />
                ))}
            </div>
        </div>
    </div>
)
